export interface IBrowseLinkApiResponse {
  city: string | null;
  insurance: string | null;
  provider_count: number;
  state: string;
  specialty: string | null;
  url: string;
}

export interface IBrowseLinkData {
  value: string;
  uriSafeValue: string;
}

export const BrowseLinkKeys = {
  CITY: 'city' as const,
  INSURANCE: 'insurance' as const,
  MODALITY: 'modality' as const,
  PSYCHIATRIST: 'psychiatrist' as const,
  SPECIALTY: 'specialty' as const
};

export type BrowseLinkKeyType = typeof BrowseLinkKeys[keyof typeof BrowseLinkKeys];
